import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { calculateDB, calculateGrowth } from "./calculations"

export const getRevenueStatsForAdms = async ({ admNumbers, year, limit, page, sort }) => {
  const sortString = EinzaGraphiQLService.formatSortParam(sort)
  const currentMonth = new Date().getMonth() + 1
  const defaultSort = "admNumber.asc"

  const sortComputedValue =
    sort &&
    ["yearDB", "revenueGrowth"].some((substring) => sort.orderBy.toLowerCase().includes(substring.toLowerCase()))

  const graphiQLQueryObject = [
    {
      method: "admStats: findRlStatsForAdmsInYear",
      variables: {
        admNumbers: admNumbers.join(","),
        year: year,
        month: currentMonth,
        page: page,
        size: limit,
        sort: sortComputedValue ? defaultSort : sortString,
      },
      fields: ["number", "numberOfElements", "totalElements", "totalPages"],
      expandedFields: {
        content: [
          "year",
          "month",
          "admNumber",
          "admName",
          "revenueYtd",
          "marginYtd",
          "revenueMtd",
          "revenueMtdPreviousYear",
        ],
      },
    },
  ]

  const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)

  const einzaResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.admStats

  if (!einzaResponse?.content || einzaResponse?.content?.length === 0) {
    return {
      items: [],
      limit: 0,
      page: 0,
      total: 0,
    }
  }

  const currentYear = String(new Date().getFullYear())

  const queryObject = []
  const openOrderFilter = [
    { field: "year", operator: "eq", value: currentYear },
    { field: "orderType", operator: "in", value: "AU;NL;DL;BA" },
    { field: "orderStatus", operator: "eq", value: "G" },
  ]
  admNumbers.flat().forEach((admNumber) => {
    const admQueryObject = {
      method: `openOrders_${admNumber}: findOrdersCountAndNetInvoiceSumByAdmAndFilter`,
      variables: {
        admNumber: admNumber,
        filters: openOrderFilter,
      },
      fields: ["admNumber", "orderNetInvoiceSum"],
    }
    queryObject.push(admQueryObject)
  })

  const openOrderMappedQuery = EinzaGraphiQLService.formQuery(queryObject)

  const openOrdersResponse = (await EinzaGraphiQLService.getData(openOrderMappedQuery))?.data

  let items = einzaResponse?.content.map((item) => ({
    admName: item.admName,
    admNumber: item.admNumber,
    currentYearMarginRaw: item.marginYtd,
    currentYearMargin: calculateDB(item.marginYtd, item.revenueYtd),
    currentYearMonthlyRevenue: item.revenueMtd,
    currentYearRevenue: item.revenueYtd,
    lastYearMonthlyRevenue: item.revenueMtdPreviousYear,
    monthlyRevenueGrowth: calculateGrowth(item.revenueMtd, item.revenueMtdPreviousYear),
    orderNetInvoiceSum: openOrdersResponse[`openOrders_${item.admNumber}`]?.orderNetInvoiceSum,
  }))

  if (sortComputedValue) {
    switch (sort?.orderBy) {
      case "yearDB":
        items = sortItems(items, "currentYearMargin", sort.direction)
        break
      case "revenueGrowth":
        items = sortItems(items, "monthlyRevenueGrowth", sort.direction)
        break
      default:
        items = sortItems(items, "admNumber", sort.direction)
    }
  }

  return {
    items: items,
    limit: einzaResponse.numberOfElements,
    page: page,
    total: einzaResponse.totalElements,
  }
}

function sortItems(items, key, order = "asc") {
  return items.sort((a, b) => {
    if (a[key] < b[key]) {
      return order === "asc" ? -1 : 1
    }
    if (a[key] > b[key]) {
      return order === "asc" ? 1 : -1
    }
    return 0
  })
}
